jQuery('#Do_date, #Od_date').change(function(e){
    jQuery('.gddkia-reset-filters').show();
});

jQuery('body').on('click', '.gddkia-reset-filters', function(e){
    e.preventDefault();
    jQuery('#Do_date, #Od_date').val('');
    jQuery('.gddkia-filter-button').click();
});